import React from 'react'
import Section from '../_common/Section'

export default () => {
  // console.log('rendering owners')
  const labels = [
    {
      id: 'id',
      name: 'オーナーID'
    },
    {
      id: 'name',
      name: '管理会社名・オーナー名'
    },
    {
      id: 'registered_users',
      name: '現在のアプリ利用数'
    },
    {
      id: 'created_date',
      name: '作成日'
    },
    {
      id: 'csv_url',
      name: 'CSVダウンロード'
    },
    {
      id: 'push',
      name: 'プッシュ通知'
    },
    {
      id: 'chat',
      name: 'チャット'
    }
  ]

  return (
    <Section
      title="管理会社・オーナー検索"
      category="owners"
      mainID="id"
      labels={labels}
      // labels={['ID', '管理会社名・オーナー名', '電話番号', '住所', '作成日']}
      // labelsID={[ 'id', 'name', 'tel', 'address', 'created' ]}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Owners/index.js